import ThermicTypo from "@/models/enums/thermic-typo.ts";
import { ShellThermalListboxItem } from "./shell-thermal-item";

const thermalsType: ShellThermalListboxItem[] = [
    {
        label : 'Aucun',
        keyName: ThermicTypo.Aucun,
        color: '#d1c9c6',
        description: ''
    },
    {
        label : 'Chauffé',
        keyName: ThermicTypo.Chauffe,
        color: '#fb572b',
        description: ''
    },
    {
        label : 'Non chauffé',
        keyName: ThermicTypo.NonChauffe,
        color: '#2b47fb',
        description: ''
    },
    {
        label : 'Extérieur',
        keyName: ThermicTypo.Exterieur,
        color: '#cefb2b',
        description: ''
    }
]

export default thermalsType;